import styled from "styled-components"
import { IWaterHistoryItem } from "../types"
import AnimatedValue from "./AnimatedValue"
import { IBodyDisplayUnits } from "features/profile/profileTypes"
import { getDisplayWaterVolume, getWaterUnit } from "utils/waterVolumeConverter"

const TEAL = "#2CCCD3"

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-top: 16px;
`

const Row = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  height: 30px;
`

const TimeCell = styled.div<{ $highlighted?: boolean }>`
  width: 80px;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.6;
  color: ${({ $highlighted }) =>
    $highlighted ? TEAL : "rgba(255, 255, 255, 0.8)"};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const DetailsCell = styled.div<{ $highlighted?: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 10px;
  height: 28px;
  padding: 0 4px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.6;
  color: ${({ $highlighted }) =>
    $highlighted ? TEAL : "rgba(255, 255, 255, 0.8)"};
`

const Label = styled.span`
  flex: 1;
  color: inherit;
  overflow: hidden;
  white-space: nowrap;
`

const AmountWrapper = styled.div`
  display: flex;
  gap: 2px;
  align-items: center;
  justify-content: flex-end;
  width: 80px;
  text-align: right;
`

const Amount = styled.span`
  color: inherit;
`

const Unit = styled.span`
  color: inherit;
`

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
`

const WaterHistory = ({
  waterHistory,
  selectedDate,
  loading,
  disableAnimation,
  bodyDisplayUnits,
}: {
  waterHistory: IWaterHistoryItem[]
  selectedDate: string | null
  loading: boolean
  disableAnimation?: boolean
  bodyDisplayUnits: IBodyDisplayUnits
}) => {
  const filteredHistory = waterHistory.filter(
    (item) => getDisplayWaterVolume(bodyDisplayUnits, item.amount) > 0,
  )

  return (
    <Wrapper>
      {filteredHistory.map((item, index) => {
        const isHighlighted =
          selectedDate !== null && item.date === selectedDate
        return (
          <div key={index}>
            <Row>
              <TimeCell $highlighted={isHighlighted}>{item.date}</TimeCell>
              <DetailsCell $highlighted={isHighlighted}>
                <Label>Hydration</Label>
                <AmountWrapper>
                  <Amount>
                    <AnimatedValue
                      value={getDisplayWaterVolume(
                        bodyDisplayUnits,
                        item.amount,
                      )}
                      loading={loading}
                      skipFirstTransition={false}
                      disableAnimation={disableAnimation}
                      decimals={bodyDisplayUnits === "IMPERIAL" ? 1 : 0}
                    />
                  </Amount>
                  <Unit>{getWaterUnit(bodyDisplayUnits)}</Unit>
                </AmountWrapper>
              </DetailsCell>
            </Row>
            {index < filteredHistory.length - 1 && <Divider />}
          </div>
        )
      })}
    </Wrapper>
  )
}

export default WaterHistory
